import { ServiceGenqlSelection } from '@rematter/frontend-lib-api-client';

export const SERVICE_FRAGMENT = {
  id: true,
  serviceType: {
    __typename: true,
    id: true,
    name: true,
  },
  status: true,
  assignmentStatus: true,
  driverProgress: true,
  haulerProgress: true,
  documentNumber: true,
  rank: true,
  priority: true,
  facilityId: true,
  scheduledWindowStart: true,
  scheduledWindowEnd: true,
  routeId: true,
  routePosition: true,
  startedAt: true,
  completedAt: true,
  assignedAt: true,
  estimatedArrival: true,
  internalNotes: true,
  externalNotes: true,
  driverNotes: true,
  address: {
    streetAddress: true,
    city: true,
    state: true,
    postalCode: true,
    country: true,
    addressType: true,
    isMailingAddress: true,
    coordinates: { latitude: true, longitude: true },
  },
  driverId: true,
  haulerId: true,
  truckId: true,
  trailerId: true,
  facilityGroupId: true,
  destinationFacilityId: true,
  accountId: true,
  account: {
    id: true,
    name: true,
  },
  accountAddressId: true,
  facility: {
    id: true,
    address: {
      streetAddress: true,
      city: true,
      state: true,
      postalCode: true,
      country: true,
      coordinates: { latitude: true, longitude: true },
    },
  },
  accountAddress: {
    id: true,
    name: true,
    address: {
      streetAddress: true,
      city: true,
      state: true,
      postalCode: true,
      country: true,
      coordinates: { latitude: true, longitude: true },
    },
  },
  driver: {
    id: true,
    firstName: true,
    lastName: true,
  },
  truck: {
    id: true,
    licensePlate: true,
  },
  trailer: {
    id: true,
    licensePlate: true,
  },
  actions: {
    assetTypeId: true,
    quantity: true,
    assetGroup: true,
    assetType: {
      id: true,
      name: true,
      capacity: true,
    },
  },
  timestamps: {
    createdAt: true,
    updatedAt: true,
  },
  relationshipType: true,
} as const satisfies ServiceGenqlSelection;
